import { __makeTemplateObject, __spreadArray } from '../node_modules/tslib/tslib.es6.js';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Colors } from '../Colors.js';

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", ";\n  padding-left: ", ";\n"], ["\n  margin: ", ";\n  padding-left: ", ";\n"])), function (props) { return props.margin; }, function (props) { return props.paddingLeft; });
var Input = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: ", ";\n  height: ", ";\n  width: ", ";\n  background-color: ", ";\n  transition: all 0.1s;\n  margin-right:", "; \n  outline: 0px;\n  font-size: ", ";\n  text-align: center;\n  border-radius: ", ";\n  -moz-appearance: textfield;\n  padding: 0px;\n  box-shadow: none;\n  font-weight:", "; \n  font-family:", ";\n  color: ", ";\n  -moz-appearance: textfield;\n\n  &:focus {\n     border: ", ";\n  }\n  &::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n"], ["\n  border: ", ";\n  height: ", ";\n  width: ", ";\n  background-color: ", ";\n  transition: all 0.1s;\n  margin-right:", "; \n  outline: 0px;\n  font-size: ", ";\n  text-align: center;\n  border-radius: ", ";\n  -moz-appearance: textfield;\n  padding: 0px;\n  box-shadow: none;\n  font-weight:", "; \n  font-family:", ";\n  color: ", ";\n  -moz-appearance: textfield;\n\n  &:focus {\n     border: ", ";\n  }\n  &::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n"])), function (props) {
    return props.height ? "".concat(props.border) : "2px solid ".concat(Colors.Grey5);
}, function (props) { return props.height || "70px"; }, function (props) { return props.width || "55px"; }, function (props) { return props.bgColor || "white"; }, function (props) { return props.marginRight || "10px"; }, function (props) { return props.fontSize || "24px"; }, function (props) { return props.borderRadius || "10px"; }, function (props) { return props.fontWeight; }, function (props) { return props.fontFamily; }, function (props) { return props.color; }, function (props) { return props.borderHover || "2px solid ".concat(Colors.Grey1); });
var CodeInput = function (_a) {
    var onChange = _a.onChange, onComplete = _a.onComplete, _b = _a.length, length = _b === void 0 ? 4 : _b, _c = _a.resetCode, resetCode = _c === void 0 ? false : _c, color = _a.color, placeholder = _a.placeholder, height = _a.height, width = _a.width, border = _a.border, bgColor = _a.bgColor, borderRadius = _a.borderRadius, borderHover = _a.borderHover, fontSize = _a.fontSize, marginRight = _a.marginRight, fontWeight = _a.fontWeight, fontFamily = _a.fontFamily, paddingLeft = _a.paddingLeft;
    var _d = useState(new Array(length).fill("")), value = _d[0], setValue = _d[1];
    useEffect(function () {
        if (resetCode) {
            setValue(new Array(length).fill(""));
        }
    }, [resetCode]);
    var inputs = [];
    var change = function (valueAt, index) {
        var currentValue = __spreadArray([], value, true);
        if (valueAt.length > 1) {
            valueAt = valueAt.substring(1);
        }
        // Single Character Press
        if (valueAt.length === 1) {
            currentValue[index] = valueAt;
            setValue(currentValue);
            if (inputs[index + 1]) {
                inputs[index + 1].focus();
            }
        }
        else if (valueAt.length === length) {
            //code pasted
            setValue(valueAt.split(""));
            onComplete(valueAt);
            if (inputs[index + 1]) {
                inputs[index + 1].focus();
            }
        }
        else if (valueAt.length > 0 && valueAt.length < length) {
            // More than 1 character, less than the total number required
            change(valueAt.charAt(valueAt.length - 1), index);
        }
        if (index + 1 === length) {
            onComplete(currentValue.join(""));
        }
    };
    useEffect(function () {
        onChange && onChange(value);
    }, [value]);
    var renderInput = function (index) {
        var curValue = value[index];
        return (React.createElement(Input, { key: index, autoFocus: index === 0, value: curValue, type: "number", pattern: "\\d*", ref: function (ref) { return (inputs[index] = ref); }, onChange: function (event) {
                onChange();
                change(event.target.value, index);
            }, color: color, placeholder: placeholder, height: height, width: width, border: border, bgColor: bgColor, borderRadius: borderRadius, borderHover: borderHover, fontSize: fontSize, marginRight: marginRight, fontWeight: fontWeight, fontFamily: fontFamily, onKeyDown: function (event) {
                if (event.keyCode === 8 || event.keyCode === 46) {
                    // handle backspace or delete
                    event.preventDefault();
                    var currentValue = __spreadArray([], value, true);
                    currentValue[index] = "";
                    setValue(currentValue);
                    if (index !== 0) {
                        inputs[index - 1].focus();
                    }
                }
                else if (event.keyCode === 37) {
                    // navigate left with left arrow key
                    event.preventDefault();
                    if (index !== 0) {
                        inputs[index - 1].focus();
                    }
                }
                else if (event.keyCode === 39) {
                    // navigate right with right arrow key
                    event.preventDefault();
                    if (index !== value.length - 1) {
                        inputs[index + 1].focus();
                    }
                }
                else if (
                // prohibit weird behavior when up, down, +, or - are pressed
                event.keyCode === 38 ||
                    event.keyCode === 40 ||
                    event.keyCode === 107 ||
                    event.keyCode === 109) {
                    event.preventDefault();
                }
            } }));
    };
    return (React.createElement(Container, { paddingLeft: paddingLeft }, value.map(function (_, index) {
        return renderInput(index);
    })));
};
var templateObject_1, templateObject_2;

export { CodeInput as default };
//# sourceMappingURL=CodeInput.js.map
